import { takeEvery, put, call } from "redux-saga/effects";

import {
  getAdsAPI,
  addAdAPI,
  getAdAPI,
  updateAdAPI,
  deleteAdAPI,
  uploadAdBannerAPI,
} from "../../helpers/backend.helper";
import {
  GET_ADS,
  ADD_AD,
  GET_AD,
  UPDATE_AD,
  DELETE_AD,
  UPLOAD_AD_BANNER,
} from "./actionTypes";
import {
  addAdError,
  addAdSuccess,
  deleteAdError,
  deleteAdSuccess,
  getAdError,
  getAdsError,
  getAdsSuccess,
  getAdSuccess,
  updateAdError,
  updateAdSuccess,
  uploadAdBannerSuccess,
  uploadAdBannerError,
} from "./actions";

function* getAds({ payload: { request } }) {
  try {
    const response = yield call(getAdsAPI, request);
    if (response) {
      yield put(getAdsSuccess(response?.data));
    }
  } catch (error) {
    yield put(getAdsError(error));
  }
}

function* addAd({ payload: { request } }) {
  try {
    const response = yield call(addAdAPI, request);
    if (response) {
      yield put(addAdSuccess());
    }
  } catch (error) {
    yield put(addAdError(error));
  }
}

function* getAd({ payload: { id } }) {
  try {
    const response = yield call(getAdAPI, id);
    if (response) {
      yield put(getAdSuccess(response?.data));
    }
  } catch (error) {
    yield put(getAdError(error));
  }
}

function* updateAd({ payload: { request } }) {
  try {
    const response = yield call(updateAdAPI, request);
    if (response) {
      yield put(updateAdSuccess());
    }
  } catch (error) {
    yield put(updateAdError(error));
  }
}

function* deleteAd({ payload: { id } }) {
  try {
    const response = yield call(deleteAdAPI, id);
    if (response) {
      yield put(deleteAdSuccess());
    }
  } catch (error) {
    yield put(deleteAdError(error));
  }
}

function* uploadAdBanner({ payload: { banner, lang } }) {
  try {
    if (!banner.id) {
      const response = yield call(uploadAdBannerAPI, banner);
      if (response) {
        yield put(uploadAdBannerSuccess(response?.data, lang));
      }
    } else {
      yield put(
        uploadAdBannerSuccess({ id: banner.id, url: banner.dataURL }, lang)
      );
    }
  } catch (error) {
    yield put(uploadAdBannerError(error));
  }
}

function* adsSaga() {
  yield takeEvery(GET_ADS, getAds);
  yield takeEvery(ADD_AD, addAd);
  yield takeEvery(GET_AD, getAd);
  yield takeEvery(UPDATE_AD, updateAd);
  yield takeEvery(DELETE_AD, deleteAd);
  yield takeEvery(UPLOAD_AD_BANNER, uploadAdBanner);
}

export default adsSaga;
